import { createAction } from '@reduxjs/toolkit';

import type { SlideTranslatedText, SupportedLanguages } from 'js/src/client';
import { TRANSLATIONS_ACTIONS } from 'js/src/data/translations/translations-types';
import type { ImmutableMap } from 'js/src/libs/consts';

export const storeVideoTranslations = createAction<{
    translations: Immutable.List<ImmutableMap<SlideTranslatedText>>;
}>(TRANSLATIONS_ACTIONS.STORE_TRANSLATIONS);

export const storeSupportedLanguages = createAction<{
    supported_languages: Immutable.List<ImmutableMap<SupportedLanguages>>;
}>(TRANSLATIONS_ACTIONS.STORE_SUPPORTED_LANGUAGES);

export const storeLoadingSupportedLanguages = createAction<{
    is_loading: boolean;
}>(TRANSLATIONS_ACTIONS.STORE_LOADING_SUPPORTED_LANGUAGES);
